(() => {
  const form = document.getElementById('ContactForm');
  if (!form || form.dataset.sbMeasurementBound === 'true') return;

  form.dataset.sbMeasurementBound = 'true';

  const storageKey = 'sb.measurement.contact.pending';
  const maxAgeMs = 30 * 60 * 1000;
  const success = form.querySelector('[data-sb-lead-success="contact_quote"]');

  if (success) {
    let pending = null;

    try {
      pending = JSON.parse(window.sessionStorage.getItem(storageKey));
    } catch (_) {
      pending = null;
    }

    const isCurrentSubmission =
      pending &&
      Number.isFinite(pending.timestamp) &&
      Date.now() - pending.timestamp >= 0 &&
      Date.now() - pending.timestamp <= maxAgeMs &&
      pending.pagePath === window.location.pathname;

    if (isCurrentSubmission) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'sb_generate_lead',
        lead_type: 'contact_quote',
        form_id: 'ContactForm',
        page_path: window.location.pathname,
      });

      // Publish the same non-PII success signal into Shopify's consent-aware
      // customer-events pipeline for the connected custom measurement pixel.
      try {
        const publishResult = window.Shopify?.analytics?.publish?.('stoveboss:generate_lead', {
          lead_type: 'contact_quote',
          form_id: 'ContactForm',
          page_path: window.location.pathname,
        });
        publishResult?.catch?.(() => {});
      } catch (_) {
        // Measurement must never interfere with the confirmed form success page.
      }

      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (_) {
        // A blocked storage API must not affect the form success page.
      }
    }
  }

  form.addEventListener('submit', () => {
    try {
      window.sessionStorage.setItem(
        storageKey,
        JSON.stringify({
          timestamp: Date.now(),
          pagePath: window.location.pathname,
        })
      );
    } catch (_) {
      // The contact form must keep working when sessionStorage is unavailable.
    }
  });
})();
